import 'v-calendar/lib/v-calendar.min.css';
import VCalendar from 'v-calendar';
import Clipboard from 'v-clipboard';
import Vue from 'vue';
import Echo from 'laravel-echo';
import VueMeta from 'vue-meta';
import Portal from 'portal-vue';
import VueFacebookPixel from 'vue-analytics-fb';
import Datetime from 'vue-datetime';
import App from './App.vue';
import './font-awesome';
import router from './routes/index';
import store from './store/index';
import MozInput from './helpers/input_material_like.vue';
import Spinner from './views/partners/spiner.vue';
import scrollBehaviorPolyfill from 'scroll-behavior-polyfill';
import VueYoutube from 'vue-youtube';

import './directives/all';
// eslint-disable-next-line
import 'vue-datetime/dist/vue-datetime.css';
import './style/app.scss';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_MIX_PUSHER_APP_KEY,
  wsHost: `${process.env.VUE_APP_BACKEND_WS}`,
  cluster: process.env.VUE_APP_MIX_PUSHER_APP_CLUSTER,

});

Vue.use(Datetime);
Vue.use(Clipboard);
Vue.use(VueMeta);
Vue.use(scrollBehaviorPolyfill);
Vue.use(VueYoutube);

Vue.use(VCalendar, {
  datePickerTintColor: '#BD006C',
  firstDayOfWeek: 2, // Monday
  locale: 'ru-RU',
});

Vue.use(Portal);
Vue.use(VueFacebookPixel);
Vue.config.productionTip = false;

Vue.analytics.fbq.init('213778273545319');
Vue.analytics.fbq.event('PageView');

Vue.component('moz-input', MozInput);
Vue.component('spinner', Spinner);

Vue.mixin({
  computed: {
    isMobile() {
      return this.$root.windowWidth < 640;
    },
  },
});

new Vue({
  data: {
    windowWidth: null,
  },
  created() {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', () => { console.log('resized'); this.windowWidth = window.innerWidth; });
  },
  router,
  store,
  render: h => h('div', { class: 'h-full' }, [
    h(App),
  ]),
}).$mount('#app');
